import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { promptsActions } from "./prompts.actions";
import { map, of, switchMap } from "rxjs";
import { PromptSdk } from "@sdks/prompt.sdk";
import { NotificationManager } from "@managers/notification.manager";
import { UserConfigsActions } from "@store/app.actions";

@Injectable()
export class PromptsEffects {

    public init$ = createEffect(() => this.actions$.pipe(
        ofType(UserConfigsActions.authenticated, UserConfigsActions.caseSwitched),
        map(() => promptsActions.loadPrompts({ initLoad: true }))
    ));

    public load$ = createEffect(() => this.actions$.pipe(
        ofType(promptsActions.loadPrompts),
        switchMap((props) => this.promptSdk.getPrompts('').pipe(
            switchMap((data) => {
                if (data)
                    return of(promptsActions.loadedPrompts({ prompts: data }));
                if (!props.initLoad)
                    this.displayErrorNotification('error loading prompts');
                return of(promptsActions.errorLoadingPrompts());
            }))
        )
    ));

    public patch$ = createEffect(() => this.actions$.pipe(
        ofType(promptsActions.patchPrompt),
        switchMap((props) => this.promptSdk.patch(props.promptId, props.deltaPrompt).pipe(
            switchMap((data) => {
                if (!data)
                    this.displayErrorNotification('upating the prompt');
                return of(promptsActions.loadPrompts({ initLoad: false }));
            })
        ))
    ));

    public delete$ = createEffect(() => this.actions$.pipe(
        ofType(promptsActions.removePrompt),
        switchMap((props) => this.promptSdk.delete(props.promptId).pipe(
            switchMap((data) => {
                if (!data)
                    this.displayErrorNotification('deleting the prompt');
                return of(promptsActions.loadPrompts({ initLoad: false }));
            })
        ))
    ));

    constructor(
        private actions$: Actions,
        private promptSdk: PromptSdk,
        private notificationManager: NotificationManager) { }

    private displayErrorNotification(message: string) {
        this.notificationManager.displaySnackBarMessage({
            message: `An error has occurred when ${message}. Please try again or contact Professional Service for support.`,
            type: 'error',
            ttl: 5000
        });
    }
}
